var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccueil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 133.085,
    height: 100.459,
    viewBox: "0 0 133.085 100.459",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "gray",
    stopOpacity: 0.251
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.122
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.102
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 1.312,
    y1: 1,
    x2: 1.312,
    y2: 0,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_145",
    "data-name": "Groupe 145",
    transform: "translate(0 -0.506)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1",
    "data-name": "Ellipse 1",
    cx: 0.143,
    cy: 0.143,
    r: 0.143,
    transform: "translate(39.029 0.506)",
    fill: "#fa595f"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2",
    "data-name": "Ellipse 2",
    cx: 0.143,
    cy: 0.143,
    r: 0.143,
    transform: "translate(39.458 0.506)",
    fill: "#ffc74c"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3",
    "data-name": "Ellipse 3",
    cx: 0.143,
    cy: 0.143,
    r: 0.143,
    transform: "translate(39.888 0.506)",
    fill: "#85d459"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_9",
    "data-name": "Ellipse 9",
    cx: 66.206,
    cy: 18.915,
    rx: 66.206,
    ry: 18.915,
    transform: "translate(0 63.135)",
    fill: "#f2f5f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4",
    "data-name": "Trac\\xE9 4",
    d: "M693.9,368.5s1.829-8.983,8.822-8.15c0,0,4.824.332,5.823,3.494v6.986Z",
    transform: "translate(-613.554 -322.885)",
    fill: "#535461"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_20",
    "data-name": "Trac\\xE9 20",
    d: "M399.407,301.317l-62.213-5.157-7.984,1.663.5,11.146.546.066.619,16.735,61.05,10.978,6.487-5.489V313.115l.831-.487Z",
    transform: "translate(-280.803 -252.37)",
    fill: "#ededf4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_21",
    "data-name": "Trac\\xE9 21",
    d: "M766.647,331.23l-.166,11.312-6.737,3.16-.084-11.81Z",
    transform: "translate(-647.959 -282.283)",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22",
    "data-name": "Trac\\xE9 22",
    d: "M762.675,411.55l.082,17.8-6.487,5.489.416-20.627Z",
    transform: "translate(-645.068 -350.793)",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_23",
    "data-name": "Trac\\xE9 23",
    d: "M336.606,384.965l62.135,7.583.032-1.438L336.56,384.4Z",
    transform: "translate(-287.072 -327.635)",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_24",
    "data-name": "Trac\\xE9 24",
    d: "M764.125,412.2v-.653l-6.155,2.717v1.441Z",
    transform: "translate(-646.518 -350.793)",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_25",
    "data-name": "Trac\\xE9 25",
    d: "M328.64,297.823l7.984-1.663,62.214,5.157-6.987,2.661Z",
    transform: "translate(-280.317 -252.37)",
    fill: "#f4f4f8"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_11",
    "data-name": "Ellipse 11",
    cx: 4.789,
    cy: 1.759,
    rx: 4.789,
    ry: 1.759,
    transform: "translate(120.156 68.408)",
    fill: "var(--second-color)",
    opacity: 0.641
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_12",
    "data-name": "Ellipse 12",
    cx: 2.444,
    cy: 0.897,
    rx: 2.444,
    ry: 0.897,
    transform: "translate(122.501 69.074)",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_26",
    "data-name": "Trac\\xE9 26",
    d: "M963.195,580.38s5.277,2.932,9.578.391c0,0-.588,10.163-3.519,11.141h-3.91S962.021,585.071,963.195,580.38Z",
    transform: "translate(-843.038 -510.605)",
    fill: "var(--second-color)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_27",
    "data-name": "Trac\\xE9 27",
    d: "M920.3,414.351c1.342,4.91-4.385,18.9-4.385,18.9s-12.057-9.117-13.394-14.032a9.216,9.216,0,1,1,17.779-4.864Z",
    transform: "translate(-791.218 -363.2)",
    fill: "var(--third-color)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_28",
    "data-name": "Trac\\xE9 28",
    d: "M920.3,414.351c1.342,4.91-4.385,18.9-4.385,18.9s-12.057-9.117-13.394-14.032a9.216,9.216,0,1,1,17.779-4.864Z",
    transform: "translate(-791.218 -363.2)",
    fill: "#000a32",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_29",
    "data-name": "Trac\\xE9 29",
    d: "M948.68,410s7.5,11.322,6.936,25.353",
    transform: "translate(-830.871 -365.278)",
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_30",
    "data-name": "Trac\\xE9 30",
    d: "M1003.491,512.1s-6.8-3.7-5.935,9.959c0,0,5.674-.2,7.687-4.832a4.014,4.014,0,0,0-1.647-5.07Z",
    transform: "translate(-872.496 -451.976)",
    fill: "var(--third-color)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_31",
    "data-name": "Trac\\xE9 31",
    d: "M1004.012,514.91s-.882,7.09-6.052,9.935",
    transform: "translate(-872.905 -454.762)",
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_32",
    "data-name": "Trac\\xE9 32",
    d: "M984.974,583.372c-.2,2.338-1.009,9.6-3.464,10.418H978c.112.25.179.391.179.391h3.91c2.932-.978,3.519-11.141,3.519-11.141A7.127,7.127,0,0,1,984.974,583.372Z",
    transform: "translate(-855.88 -512.874)",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_13",
    "data-name": "Ellipse 13",
    cx: 5.489,
    cy: 5.489,
    r: 5.489,
    transform: "translate(96.148 16.343)",
    fill: "#535461"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_14",
    "data-name": "Ellipse 14",
    cx: 4.658,
    cy: 4.658,
    r: 4.658,
    transform: "translate(96.979 17.174)",
    fill: "#ededf4"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_15",
    "data-name": "Ellipse 15",
    cx: 0.332,
    cy: 0.332,
    r: 0.332,
    transform: "translate(101.305 21.5)",
    fill: "#535461"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Ligne_1",
    "data-name": "Ligne 1",
    x1: 1.997,
    y2: 3.494,
    transform: "translate(101.637 18.339)",
    fill: "none",
    stroke: "#535461",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Ligne_2",
    "data-name": "Ligne 2",
    x2: 1.984,
    y2: 1.044,
    transform: "translate(101.733 21.869)",
    fill: "none",
    stroke: "#535461",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_33",
    "data-name": "Trac\\xE9 33",
    d: "M202.431,252.743a3.135,3.135,0,0,1-1.029-1.982l.366-.125s-1.2-12.384-1.46-13.043a20.87,20.87,0,0,1-.531-3.03l-.431-12.916a5.338,5.338,0,0,0,3.1-2.725,3.381,3.381,0,0,0,.253-.563c-2.794-3.425-5.045-12.645-5.045-12.645l.378-.973h0l.166-.428a5.538,5.538,0,0,0,3.041,3.382l-.037-.343c.1.049.159.075.168.078a1.708,1.708,0,0,0,1.6.4c1.629-.622,1.6-3.473,1.594-3.791v-.294l-1.6-5.929a5.07,5.07,0,0,1-.2.882,20.933,20.933,0,0,1,.072-4.836c.313-1.453-2.75-.453-3.545,1.26a3.135,3.135,0,0,0-2.429-1.265,8.035,8.035,0,0,1-5-2.189,8.344,8.344,0,0,1-.163-.91,4.325,4.325,0,0,0,1.387-3.91,2.223,2.223,0,0,0,.209-.107,3.56,3.56,0,0,0,1.363-2.986v-.185c.015-.378-.072-.845-.441-.922-.484-.1-.838.626-1.323.548a.735.735,0,0,1-.384-.231c-.334-.331-.559-.756-.89-1.087a3.041,3.041,0,0,0-1.9-.806,7.146,7.146,0,0,0-2.088.2,3.448,3.448,0,0,0-1.075.365,1.284,1.284,0,0,0-.647.882,1.447,1.447,0,0,0-.007.241c0,.122,0,.247.01.369a1,1,0,0,1-.018.159,1.3,1.3,0,0,1-.66.791c-.3.181-.644.307-.931.515a2.444,2.444,0,0,0-.9,1.422,3.93,3.93,0,0,0-.1.972,6.27,6.27,0,0,0,.051.882,9.382,9.382,0,0,0,.819,2.841,4.018,4.018,0,0,0,.532.882,4.944,4.944,0,0,0,1.075.882.657.657,0,0,0,.54.16.469.469,0,0,0,.147-.088,1.159,1.159,0,0,0,.357-.95.983.983,0,0,0,.016.115l.026.012a4.484,4.484,0,0,1,0,.715,15.889,15.889,0,0,1-3.776,2.364,4.6,4.6,0,0,0-2.647,2.932,10.209,10.209,0,0,1-1.25,2.711c-.266.4-1.46,5.8-2.257,6.851-.666.882,2.014,5.735,3.919,7.6l.085.081a3.19,3.19,0,0,0,1.176.882,6.046,6.046,0,0,1-.074-.9c.216.294.425.581.613.865-.078.416-.169.825-.275,1.223-1.323,5-.531,5.138-.531,5.138s.04.019.109.046c.069.2.156.218.156.218s.041.021.116.049a102.22,102.22,0,0,0,.945,12.072s-.8,7.9-.4,9.353,0,7.646,0,7.646l.272.072a4.138,4.138,0,0,1-1.069,2.3c-1.2,1.054-2.389,2.9-.8,3.425s3.717.132,3.982-1.45l.132-1.185,1.859-.659-.318-2.206c.523-.837-.081-5.041-.081-5.041s.4-1.45.929-10.012c.015-.241.032-.475.05-.707,0-.068.01-.134.016-.2q.022-.263.047-.519c0-.059.012-.119.018-.178.022-.219.046-.441.071-.648,0-.032.009-.065.012-.1q.034-.272.069-.535l.025-.182q.034-.24.071-.471a.834.834,0,0,1,.021-.135q.047-.294.1-.569l.024-.125q.04-.219.082-.432l.032-.16q.046-.224.093-.441l.018-.082q.057-.254.115-.494l.031-.128q.046-.184.091-.36l.035-.134c.04-.147.079-.294.121-.441v-.012c.041-.147.084-.285.126-.423l.037-.119q.049-.154.1-.3l.035-.106c.043-.128.085-.253.128-.373l.019-.051q.056-.156.112-.3l.038-.1q.05-.132.1-.257l.031-.076q.063-.157.126-.3l.028-.065q.05-.116.1-.226l.038-.084.1-.218.021-.046c.04-.084.079-.163.118-.24l.032-.062.085-.166.034-.063.1-.185v-.013l.1-.178.029-.05a6.282,6.282,0,0,1,.531-.794s4.666,11.335,4.538,13.309a34.411,34.411,0,0,0,.8,6.323s.4,1.45.531,2.372c.113.784.8,3.85,1,4.754h0l.032.147v.016l.009.04v.035l-.129,1.6,1.726,1.054c.929,2.635,2.92,2.5,4.514,1.844S203.493,253.395,202.431,252.743Zm-1.944-53.586-.021-.018v-.025ZM183.1,210.96c-.1-.079-.194-.168-.294-.262a4.693,4.693,0,0,1-.322-.375l.071.076c.1.1.206.188.3.269a45.089,45.089,0,0,0-.182-4.524c.065-.109.124-.2.176-.284A43.7,43.7,0,0,1,183.1,210.96Z",
    transform: "translate(-172.517 -170.001)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_34",
    "data-name": "Trac\\xE9 34",
    d: "M215.7,247.233v.032l-.031-.046Zm-4.016,19.483a2.917,2.917,0,0,1-.951-2.112,6.136,6.136,0,0,1,1-2.779,44.476,44.476,0,0,1,.249,5.154C211.88,266.9,211.78,266.81,211.68,266.716Zm17.726-11.706.022.04-.021-.018Z",
    transform: "translate(-201.424 -226.433)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_35",
    "data-name": "Trac\\xE9 35",
    d: "M321.358,641s.129,2.454,1.162,3.1,3.1,2.97,1.55,3.616-3.486.775-4.391-1.807L318,644.879l.259-3.235Z",
    transform: "translate(-292.927 -562.311)",
    fill: "#1a2246"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_36",
    "data-name": "Trac\\xE9 36",
    d: "M205.834,646.25s0,2.454-1.162,3.486-2.325,2.841-.775,3.357,3.616.129,3.875-1.42l.129-1.162,1.807-.646-.516-3.616Z",
    transform: "translate(-194.965 -566.789)",
    fill: "#1a2246"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_37",
    "data-name": "Trac\\xE9 37",
    d: "M231.675,401.677l.516,15.625a20.6,20.6,0,0,0,.516,2.97c.257.646,1.42,12.782,1.42,12.782l-3.745,1.291s-.9-4-1.029-4.907a23.464,23.464,0,0,0-.516-2.325,33.545,33.545,0,0,1-.775-6.2c.129-1.934-4.391-13.042-4.391-13.042s-2.711,3.235-3.235,11.616-.9,9.813-.9,9.813.645,4.52,0,5.036-3.875-.387-3.875-.387.387-6.068,0-7.489.387-9.168.387-9.168-2.448-17.032.651-20.4l13.429-.9Z",
    transform: "translate(-205.18 -353.336)",
    fill: "#3b477b"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_2",
    "data-name": "Groupe 2",
    transform: "translate(13.184 42.659)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_38",
    "data-name": "Trac\\xE9 38",
    d: "M315.982,433.029s-1.162-12.138-1.42-12.784a20.4,20.4,0,0,1-.516-2.97l-.516-15.623L312,396.021l.76-.051,1.55,5.682.516,15.625a20.606,20.606,0,0,0,.516,2.97c.257.645,1.415,12.782,1.415,12.782l-3.745,1.291-.056-.249Z",
    transform: "translate(-300.993 -395.97)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_39",
    "data-name": "Trac\\xE9 39",
    d: "M237.538,503.266c.646-.516,0-5.036,0-5.036s.387-1.42.9-9.813,3.235-11.616,3.235-11.616.109.266.294.723c-.8,1.362-2.366,4.739-2.744,10.9-.516,8.393-.9,9.814-.9,9.814s.646,4.52,0,5.036a1.93,1.93,0,0,1-1.184.14A.841.841,0,0,0,237.538,503.266Z",
    transform: "translate(-237.14 -464.915)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_40",
    "data-name": "Trac\\xE9 40",
    d: "M237.21,227.36s-1.029,4.648,1.807,7.1-6.715,4.391-8.393,2.325,1.162-3.1,1.162-3.1,1.42-1.162,0-4.648Z",
    transform: "translate(-217.946 -209.493)",
    fill: "#e0a17e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_41",
    "data-name": "Trac\\xE9 41",
    d: "M236.566,262.49l-3.357,3.616-2.6-3.464-2.176,10.44.775,12.128s6.2,1.679,9.684-1.55l-1.029-11.234Z",
    transform: "translate(-216.527 -239.458)",
    fill: "#f0f1f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_42",
    "data-name": "Trac\\xE9 42",
    d: "M241.293,413.54l.513,1.685s-6.068,1.029-8.136.516l.516-1.807S239.872,415.347,241.293,413.54Z",
    transform: "translate(-220.997 -368.297)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_43",
    "data-name": "Trac\\xE9 43",
    d: "M241.293,411.78l.513,1.679s-6.068,1.029-8.136.516l.516-1.807S239.872,413.587,241.293,411.78Z",
    transform: "translate(-220.997 -366.796)",
    fill: "#1a2246"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_44",
    "data-name": "Trac\\xE9 44",
    d: "M273.593,256.34a7.763,7.763,0,0,0,4.907,2.2c2.97.129,3.357,3.745,3.357,3.745l1.029,9.558a5.363,5.363,0,0,1-2.97-3.357l-.646,1.679s2.2,9.039,4.907,12.4c0,0-1.162,3.875-6.843,3.357a5.441,5.441,0,0,1-2.97-5.036l-1.007-5.661a28.9,28.9,0,0,1-.441-6.029Z",
    transform: "translate(-254.459 -234.212)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_45",
    "data-name": "Trac\\xE9 45",
    d: "M274.456,254.58a7.764,7.764,0,0,0,4.907,2.2c2.97.129,3.357,3.748,3.357,3.748l1.029,9.558a5.363,5.363,0,0,1-2.97-3.357l-.646,1.679s2.2,9.03,4.911,12.391c0,0-1.162,3.875-6.843,3.357a5.441,5.441,0,0,1-2.97-5.036l-1.015-5.652a28.9,28.9,0,0,1-.441-6.029Z",
    transform: "translate(-255.193 -232.711)",
    fill: "#293158"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_46",
    "data-name": "Trac\\xE9 46",
    d: "M190.684,260.61a10.4,10.4,0,0,1-3.411,2.492,4.5,4.5,0,0,0-2.569,2.875,9.99,9.99,0,0,1-1.216,2.657c-.259.387-1.42,5.682-2.2,6.715s3.1,7.618,4.777,8.136c0,0-.646-3.616,1.937-4,0,0-2.325-1.42-2.2-3.1a6.035,6.035,0,0,1,1.162-2.97s.9,6.586-.387,11.493-.516,5.036-.516,5.036,5.293,2.582,4.52-9.558-.129-16.658-.129-16.658Z",
    transform: "translate(-176.235 -237.854)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_47",
    "data-name": "Trac\\xE9 47",
    d: "M184.312,282.56s-.51-2.857,1.191-3.763a23.909,23.909,0,0,1-.673,5.183c-1.291,4.907-.516,5.036-.516,5.036a2.292,2.292,0,0,0,.421.147c1.238.31,4.739.326,4.1-9.7-.775-12.138-.129-16.658-.129-16.658l.516-2.97a15.522,15.522,0,0,1-3.705,2.345,4.5,4.5,0,0,0-2.569,2.875,10.043,10.043,0,0,1-1.216,2.657c-.259.387-1.42,5.682-2.2,6.715-.648.865,1.96,5.62,3.811,7.448A2.682,2.682,0,0,0,184.312,282.56Zm-.072-6.118a2.05,2.05,0,0,1-.185-.984,5.975,5.975,0,0,1,.984-2.719c.107-.162.178-.25.178-.25a41.7,41.7,0,0,1,.3,5.532,4.642,4.642,0,0,1-1.281-1.578Z",
    transform: "translate(-174.734 -237.189)",
    fill: "#293158"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_48",
    "data-name": "Trac\\xE9 48",
    d: "M244.088,233.381a4.244,4.244,0,0,1-1.86-.426,8.357,8.357,0,0,0-.588-2.156l5.423-1.679a10.378,10.378,0,0,0-.112,3.16A4.245,4.245,0,0,1,244.088,233.381Z",
    transform: "translate(-227.795 -210.994)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16",
    "data-name": "Ellipse 16",
    cx: 4.261,
    cy: 4.261,
    r: 4.261,
    transform: "translate(12.032 13.606)",
    fill: "#e0a17e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_3",
    "data-name": "Groupe 3",
    transform: "translate(23.762 34.007)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_49",
    "data-name": "Trac\\xE9 49",
    d: "M314.656,351.206c-2.711-3.357-4.907-12.4-4.907-12.4l.643-1.679a3.942,3.942,0,0,0,.238.725l-.368.954s2.2,9.036,4.908,12.4c0,0-1.06,3.529-6.09,3.4C313.666,354.484,314.656,351.206,314.656,351.206Z",
    transform: "translate(-309.08 -337.13)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_50",
    "data-name": "Trac\\xE9 50",
    d: "M330.324,271.1a25.072,25.072,0,0,1,0-5.552c.387-1.807-4.52.259-3.486,2.711a21.2,21.2,0,0,0,2.066,3.875Z",
    transform: "translate(-300.343 -241.477)",
    fill: "#e0a17e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_51",
    "data-name": "Trac\\xE9 51",
    d: "M330.525,295.86l1.55,5.811s.129,3.1-1.55,3.745-3.745-3.1-3.745-3.1l1.029-5.423S330.009,299.346,330.525,295.86Z",
    transform: "translate(-300.416 -267.921)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_52",
    "data-name": "Trac\\xE9 52",
    d: "M330.525,297.62l1.55,5.811s.129,3.1-1.55,3.745-3.745-3.1-3.745-3.1l1.029-5.423S330.009,301.106,330.525,297.62Z",
    transform: "translate(-300.416 -269.422)",
    fill: "#293158"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_53",
    "data-name": "Trac\\xE9 53",
    d: "M330.525,297.62l1.55,5.811s.129,3.1-1.55,3.745-3.745-3.1-3.745-3.1l1.029-5.423S330.009,301.106,330.525,297.62Z",
    transform: "translate(-300.416 -269.422)",
    opacity: 0.02
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_54",
    "data-name": "Trac\\xE9 54",
    d: "M211.808,351.79c-1.291,4.907-.516,5.036-.516,5.036a2.292,2.292,0,0,0,.421.147c1.3-2.619,1.522-6.9,1.409-10.587v-.09a66.715,66.715,0,0,0-.6-6.967,3.223,3.223,0,0,0-.5,1.219c.107-.162.178-.25.178-.25a41.7,41.7,0,0,1,.3,5.532,3.845,3.845,0,0,1-.018.778A24.19,24.19,0,0,1,211.808,351.79Z",
    transform: "translate(-201.713 -304.999)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_55",
    "data-name": "Trac\\xE9 55",
    d: "M212.14,391.632l.147.185h0a11.993,11.993,0,0,1,1.288,2.009c.773,1.681,3.464-2.914,1.168-4.264-.376-.219-.735-.418-1.073-.588h0l-.26-.134A3.027,3.027,0,0,0,212.14,391.632Z",
    transform: "translate(-202.632 -347.229)",
    fill: "#e0a17e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_56",
    "data-name": "Trac\\xE9 56",
    d: "M212.14,391.624l.147.185h0s.06-2.406,1.384-2.845h0l-.26-.134A3.029,3.029,0,0,0,212.14,391.624Z",
    transform: "translate(-202.632 -347.221)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_57",
    "data-name": "Trac\\xE9 57",
    d: "M227.609,190.226a1.182,1.182,0,0,1,.735-.132.834.834,0,0,1,.294.2,2.589,2.589,0,0,0,1.12.785,2.166,2.166,0,0,0,.838-.037,4.02,4.02,0,0,0,1.381-.421,3.49,3.49,0,0,0,1.323-2.928c.021-.375-.057-.86-.425-.938-.471-.1-.815.615-1.29.537a.717.717,0,0,1-.373-.226c-.324-.323-.543-.735-.866-1.066a2.953,2.953,0,0,0-1.844-.79,6.9,6.9,0,0,0-2.032.191,3.339,3.339,0,0,0-1.045.357,1.257,1.257,0,0,0-.629.869c-.032.25.035.507-.015.753a1.271,1.271,0,0,1-.643.776,10.078,10.078,0,0,0-.906.5,2.4,2.4,0,0,0-.873,1.392,4.716,4.716,0,0,0-.047,1.67,9.251,9.251,0,0,0,.791,2.785,3.945,3.945,0,0,0,.518.863,4.817,4.817,0,0,0,1.045.868.64.64,0,0,0,.525.157.455.455,0,0,0,.147-.087,1.326,1.326,0,0,0,.294-1.323,7.909,7.909,0,0,1-.332-1.388.667.667,0,0,1,.076-.387,1.708,1.708,0,0,1,.259-.26,1.56,1.56,0,0,0,.294-.485,4.6,4.6,0,0,0,.441-1.391,1.876,1.876,0,0,0-.249-1.145A1.482,1.482,0,0,0,227.609,190.226Z",
    transform: "translate(-211.264 -173.532)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_58",
    "data-name": "Trac\\xE9 58",
    d: "M227.609,189.226a1.182,1.182,0,0,1,.735-.132.834.834,0,0,1,.294.2,2.589,2.589,0,0,0,1.12.785,2.166,2.166,0,0,0,.838-.037,4.02,4.02,0,0,0,1.381-.421,3.49,3.49,0,0,0,1.323-2.928c.021-.375-.057-.86-.425-.938-.471-.1-.815.615-1.29.537a.717.717,0,0,1-.373-.226c-.324-.323-.543-.735-.866-1.066a2.953,2.953,0,0,0-1.844-.79,6.9,6.9,0,0,0-2.032.191,3.338,3.338,0,0,0-1.045.357,1.257,1.257,0,0,0-.629.869c-.032.25.035.507-.015.753a1.271,1.271,0,0,1-.643.776,10.078,10.078,0,0,0-.906.5,2.4,2.4,0,0,0-.873,1.392,4.716,4.716,0,0,0-.047,1.67,9.251,9.251,0,0,0,.791,2.785,3.945,3.945,0,0,0,.518.863,4.817,4.817,0,0,0,1.045.868.64.64,0,0,0,.525.157.455.455,0,0,0,.147-.087,1.326,1.326,0,0,0,.294-1.323,7.909,7.909,0,0,1-.332-1.388.667.667,0,0,1,.076-.387,1.708,1.708,0,0,1,.259-.26,1.561,1.561,0,0,0,.294-.485,4.6,4.6,0,0,0,.441-1.391,1.876,1.876,0,0,0-.249-1.145A1.482,1.482,0,0,0,227.609,189.226Z",
    transform: "translate(-211.264 -172.679)",
    fill: "#463e3b"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_117",
    "data-name": "Groupe 117",
    transform: "translate(48.571 13.706)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_396",
    "data-name": "Trac\\xE9 396",
    d: "M648.464,414.027a1.71,1.71,0,0,1,.172.207l8.054-.2.94-1.717,2.776,1.079-1.368,3.2a1.3,1.3,0,0,1-1.351.779l-9.1-1.1a1.705,1.705,0,1,1-.124-2.254Z",
    transform: "translate(-642.433 -390.303)",
    fill: "#ffb7b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_397",
    "data-name": "Trac\\xE9 397",
    d: "M601.4,513.554h-2.648l-1.26-10.214H601.4Z",
    transform: "translate(-569.111 -440.919)",
    fill: "#ffb7b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_398",
    "data-name": "Trac\\xE9 398",
    d: "M785.269,722.029H776.73v-.108a3.324,3.324,0,0,1,3.323-3.323h5.216Z",
    transform: "translate(-752.308 -646.826)",
    fill: "#000a32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_399",
    "data-name": "Trac\\xE9 399",
    d: "M460.964,509.51l-2.435-1.04,2.854-9.888,3.594,1.535Z",
    transform: "translate(-452.725 -436.933)",
    fill: "#ffb7b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_400",
    "data-name": "Trac\\xE9 400",
    d: "M634.242,711.507l-7.852-3.354.042-.1a3.324,3.324,0,0,1,4.362-1.751h0l4.8,2.049Z",
    transform: "translate(-626.39 -636.304)",
    fill: "#000a32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_401",
    "data-name": "Trac\\xE9 401",
    d: "M541.321,276.77l-.192,3.1,5.6.6,5.857.627-1.724-4.712Z",
    transform: "translate(-521.907 -250.833)",
    fill: "#ffb7b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_402",
    "data-name": "Trac\\xE9 402",
    d: "M732.5,361.447l-2.253-13.167,3.769-1.235,1.107-1.518,5.387.319.791,1.772,2.873,1.357-.441,8.2-.775,3.813-.1-.049c-3.883-2.011-10.206.448-10.269.473Z",
    transform: "translate(-713.377 -334.36)",
    fill: "var(--third-color)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_403",
    "data-name": "Trac\\xE9 403",
    d: "M715.443,373.74l-3.834-1.534.016-.068c.016-.069,1.648-6.887,1.865-7.983a1.91,1.91,0,0,1,1.085-1.47l.026-.009,1.517.462.666,5.236Z",
    transform: "translate(-697.766 -348.723)",
    fill: "var(--third-color)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_404",
    "data-name": "Trac\\xE9 404",
    d: "M662.94,490.992l-5.1-1.047,8.157-22.507,2.792-7.677s1.771-6.155,2.571-8.537l.483-3.2,11.428,1.265s3.192,4.687,2.222,12.328l.439,28.717-5.1.262-4.275-28.962-7.5,15.877s-2.365,6.775-4.057,8.244Z",
    transform: "translate(-652.729 -420.21)",
    fill: "var(--main-color)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_405",
    "data-name": "Trac\\xE9 405",
    d: "M777.641,415.027a1.71,1.71,0,0,1,.269.015l5.331-6.04-.62-1.856,2.679-1.3,1.417,3.18a1.3,1.3,0,0,1-.347,1.521l-6.993,5.925a1.705,1.705,0,1,1-1.737-1.442Z",
    transform: "translate(-751.686 -384.878)",
    fill: "#ffb7b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_406",
    "data-name": "Trac\\xE9 406",
    d: "M806.553,376.835l-2.224-5.231.867-3.644.935-1.181a.538.538,0,0,1,.433,0c.345.139.638.564.872,1.264l2.084,5.937Z",
    transform: "translate(-775.424 -352.123)",
    fill: "var(--third-color)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_407",
    "data-name": "Trac\\xE9 407",
    d: "M746.991,286.012v-3.944a5.285,5.285,0,1,1,10.57,0v3.944a.711.711,0,0,1-.71.71H747.7A.711.711,0,0,1,746.991,286.012Z",
    transform: "translate(-727.4 -276.783)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_50",
    "data-name": "Ellipse 50",
    cx: 3.875,
    cy: 3.875,
    r: 3.875,
    transform: "translate(19.915 2.098)",
    fill: "#ffb7b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_408",
    "data-name": "Trac\\xE9 408",
    d: "M739.294,289.7a4.185,4.185,0,0,1,4.18-4.181h.789a4.185,4.185,0,0,1,4.18,4.181v.079h-1.667l-.568-1.592-.114,1.592h-.862l-.287-.8-.057.8h-5.595Z",
    transform: "translate(-720.953 -284.104)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_409",
    "data-name": "Trac\\xE9 409",
    d: "M769.786,303.51a.7.7,0,0,1-.056-.743c.836-1.59,2.006-4.528.453-6.339l-.112-.13h4.51v6.771l-4.1.723a.729.729,0,0,1-.126.011.707.707,0,0,1-.573-.293Z",
    transform: "translate(-746.377 -293.128)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_410",
    "data-name": "Trac\\xE9 410",
    d: "M296.592,380.06l2.049,10.164a.493.493,0,0,1-.537.594l-7.729-.759a.493.493,0,0,1-.44-.4l-1.893-9.407a.493.493,0,0,1,.493-.6H296.1A.493.493,0,0,1,296.592,380.06Z",
    transform: "translate(-285.51 -364.275)",
    fill: "#3f3d56"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccueil);
export default __webpack_public_path__ + "static/media/accueil.2b563d2f.svg";
export { ForwardRef as ReactComponent };